import React, { memo } from "react";
import { UncontrolledTooltip } from "reactstrap";

function FieldFormValue(props) {
let colorSignal = '';
  switch (props?.value) {
    case 'red':
      colorSignal = '#DF2400';
      break;
    case 'yellow':
      colorSignal = '#FEF445';
      break;
    case 'green':
      colorSignal = '#0CA789';
      break;
    case 'black':
      colorSignal = '#1A1A1A';
      break;
    case 'purple':
      colorSignal = '#652CB3';
      break;
    default:
      colorSignal = props?.value;
      break;
  }

  if (props?.type === 'signal') {
    const circleStyle = {
      margin: '5px 0px 0px 20px',
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      backgroundColor: colorSignal,
    };
    return <>
      <div key={props?.index} className="acordeon-form-content signal-values">
        <div className="signal-form-content-title" id={`tooltip-signal-title-${props?.idexTooltip}`}>
          {props?.name}
        </div>
        <UncontrolledTooltip placement="top" target={`tooltip-signal-title-${props?.idexTooltip}`}>
          {props?.name}
        </UncontrolledTooltip>
        <div style={circleStyle}></div>
      </div>
    </>;
  } else if (props?.value) {
    return (
      <div key={props?.index} className="acordeon-form-content">
        <div className="acordeon-form-content-title">
          {props?.name}
        </div>
        <div className="acordeon-form-content-value">
          {props?.value}
        </div>
      </div>
    );
  }
  else {
    return <></>;
  }

}
export default memo(FieldFormValue);
